import React from "react";
import {Row, Col} from "antd";
import MoneyInputWithCurrencySelector from "components/MoneyInputWithCurrencySelector";
import LoadingIndicator from "components/LoadingIndicator";
import {getTransferCalculatorConfiguration} from "api/api";

import "./ClientTransferCalculatorSignUp.scss";
import {formatExchangeRate, formatMoney} from "../../utils/utils";
import TransferDetailsSignUpPanel from "./TransferDetailsSignUpPanel";
import {
    getGeoLocation,
    getSourceSupportedCurrencyFromCustomizedRateByCustomerTier,
    getTargetSupportedCurrencyFromCustomizedRateByCustomerTier,
    getTransactionLimitations
} from "../../api/api";


import moment from "moment";
import CustomerTierTransferDetailsPanel from "./CustomerTierTransferDetailsPanel";

const SEND_AMOUNT_MIN = 10
const SEND_AMOUNT_MAX = 500 * 1000



export default class ClientCustomerTierTransferCalculator extends React.Component {
    state = {
        sourceValue: this.props.transfer ? this.props.transfer.sourceValue : {},
        targetValue: this.props.transfer ? this.props.transfer.targetValue : {},
        allowedSourceCurrencies: [],
        allowedTargetCurrencies: [],
        transferMode: "SOURCE",
        isConfigurationLoading: true,
        exchangeRates: null,
        feeType: 'FIXED',
        fixedFeeAmount: 10,
        feePercentageAmount: 0,
        minimumFeeFixedAmount: 0,
        transactionLimitation: [],
        supportSourceCurrenciesFromCustomerTier: [],
        supportTargetCurrenciesFromCustomerTier: [],
    };

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    loopPullDataWithCountryCode = () => {
        let temp = this;
        setTimeout(function () {
            if (localStorage.getItem("countryCode") == null) {
                temp.loopPullDataWithCountryCode();

            } else {
                temp.loadTransferCalculatorConfiguration();
                this.intervalId = setInterval(() => temp.loadTransferCalculatorConfiguration(), 300000);
            }
        }, 300)
    }

    componentDidMount() {
        let customerTier = this.props.customerTier ? this.props.customerTier : "REGULAR";
        getSourceSupportedCurrencyFromCustomizedRateByCustomerTier(customerTier).then(sourceCurrency => {
            //if haven't setup then redirect to main page
            if (sourceCurrency.length === 0) {
                window.location = "/main";
            } else {
                getTargetSupportedCurrencyFromCustomizedRateByCustomerTier(customerTier).then(targetCurrency => {
                    
                    this.setState({
                        supportSourceCurrenciesFromCustomerTier: sourceCurrency,
                        supportTargetCurrenciesFromCustomerTier:targetCurrency
                        
                    }, () => {
                        this.loopPullDataWithCountryCode();
                    });
                }).catch(e => {
                    window.location = "/main";
                });

            }

        }).catch(e => {
            window.location = "/main";
        });


    }


    onConfigurationLoaded = newConfigurationResponse => {
        let newAllowedSourceCurrencies = [];

        for (let i = 0; i < this.state.supportSourceCurrenciesFromCustomerTier.length; i++) {
            let sourceCurrency = this.state.supportSourceCurrenciesFromCustomerTier[i];
            if (!newAllowedSourceCurrencies.includes(sourceCurrency)) {
                newAllowedSourceCurrencies.push(sourceCurrency);
            }
        }

        let sourceDefaultCurrency = 'SGD';
        let targetDefaultCurrency = 'MYR';

        if (localStorage.getItem("countryCode") === 'HK' || localStorage.getItem("countryCode") === 'CN') {
            sourceDefaultCurrency = 'HKD';
            targetDefaultCurrency = 'USD';
        }

        if(!this.state.supportSourceCurrenciesFromCustomerTier.includes(sourceDefaultCurrency)){
            sourceDefaultCurrency = this.state.supportSourceCurrenciesFromCustomerTier[0];
        }
        if(!this.state.supportTargetCurrenciesFromCustomerTier.includes(targetDefaultCurrency)){
            targetDefaultCurrency = this.state.supportTargetCurrenciesFromCustomerTier[0];
        }

        let initialTransferRoute = this.props.transfer
            ? this.props.transfer.transferRoute
            : newConfigurationResponse.transferRoutes.filter(s => s.sourceCurrency === sourceDefaultCurrency && s.targetCurrency === targetDefaultCurrency)[0]
        let initialSourceValue = this.props.transfer
            ? this.props.transfer.sourceValue
            : {amount: 1000, currency: initialTransferRoute.sourceCurrency};

        let allowedTargetCurrencies = this.calculateAllowedTargetCurrencies(
            newConfigurationResponse.transferRoutes,
            initialSourceValue
        );
        let initialTargetValue = this.props.transfer
            ? this.props.transfer.targetValue
            : this.calculateTargetValueFromSourceValue(
                initialTransferRoute,
                initialSourceValue,
                newConfigurationResponse.rates
            );
        let newTransferRoute = this.findTransferRoute(newConfigurationResponse.transferRoutes, initialSourceValue.currency,initialTargetValue.currency)
        this.setState(
            {
                transferRoutes: newConfigurationResponse.transferRoutes,
                allowedSourceCurrencies: newAllowedSourceCurrencies,
                allowedTargetCurrencies: allowedTargetCurrencies,
                sourceValue: initialSourceValue,
                targetValue: initialTargetValue,
                selectedTransferRoute: initialTransferRoute,
                exchangeRates: newConfigurationResponse.regularRates,
                factors: newConfigurationResponse.factors,
                transferMode: this.props.transfer
                    ? this.props.transfer.transferMode
                    : "SOURCE",
                minimumFeeFixedAmount: initialTransferRoute.minimumFeeFixed,
                feeType: initialTransferRoute.feeType,
                fixedFeeAmount: initialTransferRoute.feeFixed,
                feePercentageAmount: newTransferRoute.feePercent ? formatMoney(newTransferRoute.feePercent * 100) : 0,
            },
            function () {
                if (this.state.feePercentageAmount != null && this.state.feePercentageAmount != 0) {
                    this.state.selectedTransferRoute.feePercent = formatExchangeRate(this.state.feePercentageAmount / 100);
                }
                // this.fireChanged();
                if (this.props.transfer === undefined || this.props.transfer.transferMode === 'SOURCE') {
                    //just recalculate target amount in first time and will calculate after 1 minute
                    const newTargetValue = this.calculateTargetValueFromSourceValue(
                        this.state.selectedTransferRoute,
                        this.state.sourceValue,
                        this.state.exchangeRates
                    );
                    this.setState({
                        targetValue: newTargetValue
                    }, () => {
                        this.fireChanged();
                    });
                } else {
                    const newSourceValue = this.calculateSourceValueFromTargetValue(
                        this.state.selectedTransferRoute,
                        this.state.sourceValue.currency,
                        this.state.targetValue
                    );

                    this.setState({
                        sourceValue: newSourceValue
                    }, () => {
                        this.fireChanged();
                    });
                }
            }
        );
    };

    calculateAllowedTargetCurrencies = (transferRoutes, sourceValue) => {
        let allowedTargetCurrencies = [];

        for (let i = 0; i < this.state.supportTargetCurrenciesFromCustomerTier.length; i++) {
            let targetCurrency = this.state.supportTargetCurrenciesFromCustomerTier[i];
            if (!allowedTargetCurrencies.includes(targetCurrency)) {
                allowedTargetCurrencies.push(targetCurrency);
            }
        }
        // let prioritizeCurrencies = [];
        // for (let i = 0; i < transferRoutes.length; i++) {
        //     let transferRoute = transferRoutes[i];
        //     if (transferRoute.sourceCurrency === sourceValue.currency) {
        //         if (!allowedTargetCurrencies.includes(transferRoute.targetCurrency)) {
        //             if (transferRoute.targetCurrency == "SGD") {
        //                 prioritizeCurrencies[0] = "SGD";
        //             } else if (transferRoute.targetCurrency == "CNY") {
        //                 prioritizeCurrencies[1] = "CNY";
        //             } else if (transferRoute.targetCurrency == "MYR") {
        //                 prioritizeCurrencies[2] = "MYR";
        //             } else if (transferRoute.targetCurrency == "IDR") {
        //                 prioritizeCurrencies[3] = "IDR";
        //             } else if (transferRoute.targetCurrency == "USD") {
        //                 prioritizeCurrencies[4] = "USD";
        //             } else {
        //                 allowedTargetCurrencies.push(transferRoute.targetCurrency);
        //             }
        //         }
        //     }
        // }
        // prioritizeCurrencies = prioritizeCurrencies.filter(function (el) {
        //     return el != null;
        // });
        // allowedTargetCurrencies.sort();
        // allowedTargetCurrencies = prioritizeCurrencies.concat(allowedTargetCurrencies);
        return allowedTargetCurrencies;
    };

    calculateTargetValueFromSourceValue(transferRoute, sourceValue, rates) {
        let fee = this.calculateFee(sourceValue.amount, transferRoute, this.state.feeType, this.state.fixedFeeAmount);
        let convertAmount = sourceValue.amount - fee;
        let targetAmount = this.convert(
            convertAmount,
            sourceValue.currency,
            transferRoute.targetCurrency,
            rates
        );
        return {amount: targetAmount, currency: transferRoute.targetCurrency};
    }

    calculateSourceValueFromTargetValue(
        transferRoute,
        sourceCurrency,
        targetValue
    ) {
        let sourceAmount = this.convert(
            targetValue.amount,
            targetValue.currency,
            sourceCurrency,
            this.state.exchangeRates
        );

        if (this.state.feeType === "FIXED") {
            if (this.state.fixedFeeAmount != null) {
                sourceAmount = sourceAmount + parseFloat(this.state.fixedFeeAmount);
            }
        }


        return {amount: sourceAmount, currency: sourceCurrency};
    }

    convert = (amount, fromCurrency, toCurrency, rates) => {

        if (this.state.transferMode === "SOURCE") {
            if (rates[fromCurrency] && rates[fromCurrency][toCurrency]) {
                return rates[fromCurrency][toCurrency] * amount;
            } else {
                return amount * 1.0 / rates[toCurrency][fromCurrency]
            }
        } else {
            if (rates[toCurrency]) {
                return amount * 1.0 / rates[toCurrency][fromCurrency]
            }
        }


    };

    calculateFee = (sourceAmount, transferRoute, feeType, fixedFeeAmount) => {
       // return 0;

        if (!transferRoute) {
            return null;
        }
        if (feeType === "FIXED") {
            return fixedFeeAmount;
        } else {
            let minFee = this.state.minimumFeeFixedAmount;
            let feeValue = sourceAmount * transferRoute.feePercent <= minFee ?  minFee: sourceAmount * transferRoute.feePercent;
            return feeValue;
        }
    };

    fireChanged = () => {
        this.props.onChange({
            sourceValue: this.state.sourceValue,
            targetValue: this.state.targetValue,
            convertedAmount: this.getConvertedAmount(),
            transferRoute: this.state.selectedTransferRoute,
            transferMode: this.state.transferMode,
            fee: this.calculateRemittanceFee()
        });


    };

    loadTransferCalculatorConfiguration = () => {

        let customerTier = this.props.customerTier ? this.props.customerTier : "REGULAR";
        getTransferCalculatorConfiguration(this.state.sourceValue.amount === undefined ? 1000 : this.state.sourceValue.amount, customerTier
            ,null,null,null,this.props.transfer?this.props.transfer.activeTabFee:null)
            .then(response => {
                this.onConfigurationLoaded(response);
                let currentDateTime = new Date();
                let dateTemp = currentDateTime.toLocaleString("en-US", {timeZone: "Asia/Singapore"});

                this.setState({
                    isConfigurationLoading: false,
                    date: moment(dateTemp).format('DD MMMM YYYY'),
                    time: moment(dateTemp).format("hh:mm:ss A") + ' (GMT+8)'
                });
            })
            .catch(error => {
                if (this.props.customerTier) {
                    window.location = "/main"
                }
                this.setState({
                    isConfigurationLoading: false
                });
            });
        getTransactionLimitations().then(response => {
            this.setState({
                transactionLimitation: response
            })
        }).catch(error => {

        });
    };

    findTransferRoute(transferRoutes, sourceCurrency, targetCurrency) {
        for (let i = 0; i < transferRoutes.length; i++) {
            if (
                transferRoutes[i].sourceCurrency === sourceCurrency &&
                transferRoutes[i].targetCurrency === targetCurrency
            ) {
                return transferRoutes[i];
            }
        }
        for (let i = 0; i < transferRoutes.length; i++) {
            if (transferRoutes[i].sourceCurrency === sourceCurrency) {
                return transferRoutes[i];
            }
        }
        return null;
    }

    onSourceAmountChanged = (newSourceValue, changeType) => {
        let newTransferMode = "SOURCE";
        this.setState({
            transferMode: newTransferMode,
        }, () => {
            if (changeType === "CURRENCY" && newTransferMode === 'TARGET') {
                let newTransferRoute = this.findTransferRoute(
                    this.state.transferRoutes,
                    newSourceValue.currency,
                    this.state.targetValue.currency
                );
                // calculation source amount base on targetAmount
                let newSourceValueTemp = this.calculateSourceValueFromTargetValue(
                    newTransferRoute,
                    newSourceValue.currency,
                    this.state.targetValue
                );

                //re calculate source amount after can get rate and fee from source amount
                if (!isNaN(newSourceValueTemp.amount)) {
                    this.calculateSourceAmountOrTargetAmountWhenSourceChanged(newSourceValueTemp.amount, newSourceValue, changeType)
                }
            } else {
                this.calculateSourceAmountOrTargetAmountWhenSourceChanged(newSourceValue.amount, newSourceValue, changeType)
            }
        })


    };
    calculateSourceAmountOrTargetAmountWhenSourceChanged = (amount, newSourceValue, changeType) => {
        let newTransferMode =
            changeType === "CURRENCY" ? this.state.transferMode : "SOURCE";
        let customerTier = this.props.customerTier ? this.props.customerTier : "REGULAR";
        getTransferCalculatorConfiguration(amount, customerTier,null,null,null,
            this.props.transfer?this.props.transfer.activeTabFee:null).then(response => {

            let newTransferRoute = this.findTransferRoute(response.transferRoutes, newSourceValue.currency, this.state.targetValue.currency);
            this.setState({
                transferMode: newTransferMode,
                feeType: newTransferRoute.feeType,
                fixedFeeAmount: newTransferRoute.feeFixed,
                minimumFeeFixedAmount: newTransferRoute.minimumFeeFixed,
                exchangeRates: Object.assign(this.state.exchangeRates, response.regularRates),
            }, () => {

                let newTargetValue = null;
                let allowedTargetCurrencies = this.calculateAllowedTargetCurrencies(
                    this.state.transferRoutes,
                    newSourceValue
                );
                if (newTransferMode === "SOURCE") {
                    newTargetValue = this.calculateTargetValueFromSourceValue(
                        newTransferRoute,
                        newSourceValue,
                        this.state.exchangeRates
                    );
                } else if (newTransferMode === "TARGET") {
                    newTargetValue = this.state.targetValue;
                    newSourceValue = this.calculateSourceValueFromTargetValue(
                        newTransferRoute,
                        newSourceValue.currency,
                        newTargetValue
                    );
                }
                this.setState(
                    {
                        sourceValue: newSourceValue,
                        targetValue: newTargetValue,
                        allowedTargetCurrencies: allowedTargetCurrencies,
                        //allowedTargetCurrencies: BETA_TARGET_CURRENCY,
                        selectedTransferRoute: newTransferRoute,
                        transferMode: newTransferMode
                    },
                    function () {
                        this.fireChanged();
                    }
                );
            })

        })
    }

    onTargetAmountChanged = (newTargetValue, changeType) => {

        if (newTargetValue === this.state.targetValue) {
            return;
        }
        let newTransferMode =
            changeType === "CURRENCY" ? "SOURCE" : "TARGET";
        this.setState({
            transferMode: newTransferMode,
        }, () => {
            if (changeType === "CURRENCY" && newTransferMode === 'SOURCE') {
                this.calculateSourceAmountOrTargetAmountWhenTargetChanged(this.state.sourceValue.amount, newTargetValue, changeType);
            } else {

                let newTransferRoute = this.findTransferRoute(
                    this.state.transferRoutes,
                    this.state.sourceValue.currency,
                    newTargetValue.currency
                );
                // calculation source amount base on targetAmount
                let newSourceValue = this.calculateSourceValueFromTargetValue(
                    newTransferRoute,
                    this.state.sourceValue.currency,
                    newTargetValue
                );
                //re calculate source amount after can get rate and fee from source amount
                if (!isNaN(newSourceValue.amount)) {
                    this.calculateSourceAmountOrTargetAmountWhenTargetChanged(newSourceValue.amount, newTargetValue, changeType);
                }
            }

        })
    };
    calculateSourceAmountOrTargetAmountWhenTargetChanged = (amount, newTargetValue, changeType) => {
        let newTransferMode =
            changeType === "CURRENCY" ? this.state.transferMode : "TARGET";
        let customerTier = this.props.customerTier ? this.props.customerTier : "REGULAR";
        getTransferCalculatorConfiguration(amount, customerTier,null,null,null,
            this.props.transfer?this.props.transfer.activeTabFee:null).then(response => {
            let newTransferRoute = this.findTransferRoute(
                response.transferRoutes,
                this.state.sourceValue.currency,
                newTargetValue.currency
            );
            this.setState({
                transferMode: newTransferMode,
                feeType: newTransferRoute.feeType,
                fixedFeeAmount: newTransferRoute.feeFixed,
                minimumFeeFixedAmount: newTransferRoute.minimumFeeFixed,
                exchangeRates: Object.assign(this.state.exchangeRates, response.regularRates),
                transferRoutes: response.transferRoutes,
            }, () => {
                let newSourceValue;
                if (newTransferMode === "SOURCE") {
                    newSourceValue = this.state.sourceValue;
                    newTargetValue = this.calculateTargetValueFromSourceValue(
                        newTransferRoute,
                        newSourceValue,
                        this.state.exchangeRates
                    );
                } else if (newTransferMode === "TARGET") {
                    newSourceValue = this.calculateSourceValueFromTargetValue(
                        newTransferRoute,
                        this.state.sourceValue.currency,
                        newTargetValue
                    );
                }
                let selectedTransferRoute = this.findTransferRoute(
                    this.state.transferRoutes,
                    newSourceValue.currency,
                    newTargetValue.currency
                );
                this.setState(
                    {
                        targetValue: newTargetValue,
                        sourceValue: newSourceValue,
                        transferMode: newTransferMode,
                        selectedTransferRoute: selectedTransferRoute
                    },
                    function () {
                        this.fireChanged();
                    }
                );
            });

        })
    }

    calculateRemittanceFee = () => {
        return this.calculateFee(
            this.state.sourceValue.amount,
            this.state.selectedTransferRoute,
            this.state.feeType,
            this.state.fixedFeeAmount
        );
    };

    getExchangeRate = transferRoute => {
        if (!transferRoute) {
            return null;
        }

        return this.state.exchangeRates[transferRoute.sourceCurrency][
            transferRoute.targetCurrency
            ];
    };

    getConvertedAmount = () => {
        if (!this.state.selectedTransferRoute) {
            return null;
        }
        let fee = this.calculateFee(
            this.state.sourceValue.amount,
            this.state.selectedTransferRoute,
            this.state.feeType, this.state.fixedFeeAmount
        );
        return this.state.sourceValue.amount - fee;
    };

    getArrivalEstimation = transferRoute => {
        if (!transferRoute) {
            return null;
        }
        return transferRoute.deliveryEstimationDays;
    };

    render() {
        let customerTier = this.props.customerTier ? this.props.customerTier : "REGULAR";
        if (this.state.isConfigurationLoading) {
            return <LoadingIndicator/>;
        }
        return (
            <div className="transfer-calculator">
                <Row>
                    <Col md={24}><div
                        style={{color: 'white', fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>
                        For {customerTier} quote rate</div></Col>
                </Row>
                <Row className={"amount-panel"}>
                    <Col md={11} className={"col-source-amount-signup"}>
                        <MoneyInputWithCurrencySelector
                            title="You Send"
                            lableColor="lightgray"
                            placeholder="Source Amount"
                            value={this.state.sourceValue}
                            allowedCurrencies={this.state.allowedSourceCurrencies}
                            minValue={this.calculateRemittanceFee() + SEND_AMOUNT_MIN}
                            maxValue={SEND_AMOUNT_MAX}
                            onChange={this.onSourceAmountChanged}
                        />
                    </Col>
                    <Col className={"bridge-line"} md={3}>
                        <span/>
                    </Col>
                    <Col md={10} className={"col-target-amount-signup"}>
                        <MoneyInputWithCurrencySelector
                            targetField={true}
                            title={
                                this.state.transferMode === "SOURCE"
                                    ? "You Get"
                                    : "You Get Exactly"
                            }
                            lableColor="gray"
                            className="currency-selector"
                            placeholder="Target Amount"
                            value={this.state.targetValue}
                            onChange={this.onTargetAmountChanged}
                            allowedCurrencies={this.state.allowedTargetCurrencies}
                        />
                    </Col>
                    <Col md={24} className={"col-transfer-detail"}>
                        <CustomerTierTransferDetailsPanel
                            dateUpdateRate={this.state.date}
                            timeUpdateRate={this.state.time}
                            sourceValue={this.state.sourceValue}
                            targetValue={this.state.targetValue}
                            fee={this.calculateRemittanceFee()}
                            exchangeRate={this.getExchangeRate(
                                this.state.selectedTransferRoute
                            )}
                            convertedAmount={this.getConvertedAmount()}
                            arrivalEstimation={this.getArrivalEstimation(
                                this.state.selectedTransferRoute
                            )}
                            factors={this.state.factors}
                            showRateInFoReference={false}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}
